'use strict';

const breakpoints = require('../../../../../../app_progamers_core/cartridge/client/default/js/breakpoints');

const { fetchMegaMenuBid } = require('./adformBidsRequest');
const adformConstants = require('./adformConstants');
const {
    addAdformPlaceholder,
    removeAdformPlaceholder
} = require('./common/adformHelperFunctions');
const adformElementEvents = require('./adformElementEvents');
const { generateBannerHtml } = require('./helpers/adformContentBuilderHelpers');

/**
 * Returns true if we should fetch adform mega menu ads (when screen is big enough to show mega menu)
 * @return {boolean} - boolean
 */
function shouldFetchMegaMenuAds() {
    return breakpoints.up('xxl');
}

/**
 * Deletes bootstrap placeholder loader around element.
 * @param {Element} fallbackElementParent - element that has placeholder logic
 */
function removeImgPlaceholder(fallbackElementParent) {
    if (!fallbackElementParent) {
        return;
    }
    fallbackElementParent.classList.remove('invisible');
    fallbackElementParent.closest('.js-img-placeholder-wrapper')
        ?.querySelector('.js-img-placeholder')
        ?.remove();
}

/**
 * Returns mega menu ad parent if exists.
 * @param {Element} megaMenuAdWrapper - ancestor element of mega menu ad
 * @return {Element} - mega menu ad parent
 */
function getMegaMenuAdParent(megaMenuAdWrapper) {
    return megaMenuAdWrapper?.querySelector('.MEGA_MENU_AD_PARENT_JS_CLASS');
}

/**
 * Init events that make adform request to get data to create banner.
 */
function initMakeRequestEvents() {
    document.addEventListener('isml:menu:ready', () => {
        document.querySelectorAll('.js-ddtmm-mega-menu-ad-wrapper').forEach(megaMenuAdWrapper => {
            const categorySlugPath = megaMenuAdWrapper.dataset.categorySlugPath;
            if (!categorySlugPath) {
                return;
            }

            const megaMenuAdParent = getMegaMenuAdParent(megaMenuAdWrapper);
            if (shouldFetchMegaMenuAds()) {
                addAdformPlaceholder(megaMenuAdWrapper);
                fetchMegaMenuBid(megaMenuAdWrapper, categorySlugPath);
            } else if (megaMenuAdParent) {
                removeImgPlaceholder(megaMenuAdParent);
            }
        });
    });
}

/**
 * Init events that wait for adform response to get processed:
 * - case bids exist => inject banner ad
 * - case no bids => remove placeholder loader if exist
 */
function initResponseHandlingEvents() {
    document.addEventListener(adformConstants.BIDS_READY_CUSTOM_EVENT_NAME, function (e) {
        const containerTypeConfig = e.detail?.containerTypeConfig;
        const additionalEventData = e.detail?.additionalEventData;
        const bids = e.detail?.bids;
        if (!containerTypeConfig
            || !additionalEventData
            || !bids
            || !bids.length
            || !containerTypeConfig.isMegaMenuAd
        ) {
            return;
        }

        const megaMenuAdWrapper = additionalEventData?.megaMenuAdWrapper;
        if (!megaMenuAdWrapper) {
            return;
        }
        let isImgLoadingLazy = true;
        const bid = bids[0];

        removeAdformPlaceholder(megaMenuAdWrapper);
        megaMenuAdWrapper.innerHTML = generateBannerHtml(bid, isImgLoadingLazy);
        const bidImg = megaMenuAdWrapper.querySelector(`.${adformConstants.BID_IMG_JS_CLASS}`);

        bidImg.addEventListener('load', () => {
            adformElementEvents.initClickEvent(bidImg, bid);
            bidImg.setAttribute('data-url', bid.impTrackerURL);
            adformElementEvents.handleMegaMenuAdInViewport(bidImg);
        });
    });

    document.addEventListener(adformConstants.NO_BIDS_CUSTOM_EVENT_NAME, function (e) {
        const containerTypeConfig = e.detail?.containerTypeConfig;
        const additionalEventData = e.detail?.additionalEventData;
        if (!containerTypeConfig || !additionalEventData || !containerTypeConfig.isMegaMenuAd) {
            return;
        }

        const megaMenuAdWrapper = additionalEventData?.megaMenuAdWrapper;
        if (!megaMenuAdWrapper) {
            return;
        }
        removeAdformPlaceholder(megaMenuAdWrapper);
    });
}

/**
 * Init adform fetch request and handling response (bids or no bids).
 *
 * Important:
 * initResponseHandlingEvents() must be called before initMakeRequestEvents()
 * => otherwise request could dispatch event (e.g. early return "no-bids" event when request not valid)
 *    that can't be processed (response handler event not initialized yet)
 */
function initRequestLifecycleEvents() {
    initResponseHandlingEvents();
    initMakeRequestEvents();
}

module.exports = {
    init: function () {
        initRequestLifecycleEvents();

        if (shouldFetchMegaMenuAds()) {
            document.addEventListener('ddtmm-mega-menu:show', (e) => {
                const mainNavigationPoint = e?.detail?.mainNavigationPoint;
                const bidImg = mainNavigationPoint?.querySelector(`.${adformConstants.BID_IMG_JS_CLASS}`);
                if (!bidImg) {
                    return;
                }
                adformElementEvents.handleMegaMenuAdInViewport(bidImg);
            });
        }
    }
};
